import React from 'react';
import { SHOW_PARAMS } from "../../../../config";

const Row = ({ affid, subid, country, blocked,  ...row }) => {
    const valuesTd = SHOW_PARAMS.map(param => <td key={param}>{row[param]}</td>);

    return (
        <tr>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{country}</td>
            {valuesTd}
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/DynamicCutoff/components/Table/components/Row/index.js